module.exports = __webpack_public_path__ + "public/adminIcons/manageReservation.svg?faa1899e";